import { useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthShell, Field, FormError } from "./AuthShell";
import { useAuth } from "../../lib/auth";
import { formatApiError } from "../../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const next = params.get("next") || "/account";

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(form.email, form.password);
      navigate(u.role === "admin" ? "/admin" : next);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Sign in" subtitle="Welcome back. Sign in to see your certificate requests." testid="login-page">
      <title>Sign in | Vata Infrastructures</title>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field id="li-email" label="Email" type="email" autoComplete="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" />
        <Field id="li-pass" label="Password" type="password" autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" />
        <div className="text-right text-sm"><Link to="/forgot-password" data-testid="login-forgot-link" className="font-semibold text-[var(--rust)] hover:underline">Forgot password?</Link></div>
        <FormError error={error} />
        <button type="submit" disabled={busy} data-testid="login-submit" className="btn-rust flex w-full items-center justify-center gap-2 py-4 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
      <p className="mt-8 text-sm text-[var(--muted-ink)]">New here? <Link to="/register" data-testid="login-register-link" className="font-semibold text-[var(--ink)] underline">Create an account</Link></p>
    </AuthShell>
  );
}
